import BaseObject from "./BaseObject";
import Page from "./Page";
import BaseModel from "./BaseModel";
import PageGroupTreeViewModel from "../modelTreeViews/PageGroupTreeviewModel";
import { compareProperties, copyAllProperties, sortArrayByProperty } from "./utils";
import BaseModelMap from "./BaseModelMap";

//////////////////////////////////////////////////
import ObjectFactory from "./ObjectFactory";
import PageReference from "./PageReference";
import { itx } from "../translationItx/itx";
import { pageTypeInfo, PageTypes } from "./PageTypes";

ObjectFactory.registerClass("PageGroup", (data?: any, parent?: BaseModel) => {
  return new PageGroup(data, parent);
});
//////////////////////////////////////////////////

export enum fixedPageGroupTags {
  lists = "01",
  roomplan = "02",
  floorplan = "03",
  buildingPlans = "10",
}

export default class PageGroup extends BaseModel {
  public get className(): string {
    return "PageGroup"; // no itx
  }

  // public class properties
  pages = new BaseModelMap<Page>(Page, this, "p");
  pageGroups = new BaseModelMap<PageGroup>(PageGroup, this, "g");

  get sortedPages(): Array<Page | PageReference> {
    return this.pages.sortBy("tagOrName");
  }

  constructor(data?: any, parent?: BaseObject) {
    super(data, parent);
    this.treeViewModel = new PageGroupTreeViewModel(this);
    copyAllProperties(data, this);
  }

  // save & load

  delete(): Array<BaseObject> {
    this.isDeleting = true;

    var res = new Array<BaseObject>();

    // delete all child pages
    res = res.concat(this.pages.deleteAllItems());

    // delete this
    res = res.concat(super.delete());
    return res;
  }

  compareTo(other: any): string[] {
    return compareProperties(this, other, ...["id", "name", "pages"]); // no itx
  }

  getPersistentProperties(): string[] {
    return ["pages", "pageGroups", ...super.getPersistentProperties()]; // no itx
  }

  canBeDeletedInteractive(): boolean {
    if (this.tag == fixedPageGroupTags.buildingPlans) {
      return false;
    }
    return true;
  }

  static initPageGroups() {
    // check and create pagegroups for lists which will be not dynamic

    // if there are no pagegroups, we have to create all ( first time in project)
    if (state.pageGroups.size == 0) {
      let count = 0;
      for (let pagetypeString in PageTypes) {
        if (pageTypeInfo(PageTypes[pagetypeString]).isList) {
          const pageType = PageTypes[pagetypeString];

          // create new project add all pagegroups for lists which will be not dynamic

          let name = itx("pageDocumentType." + pageType, pageType);
          {
            const pgL = new PageGroup(
              {
                name: name,
                tag: name.substring(0, 2).toUpperCase() + count, // to avoid double tags if there are more lists
              },
              state.pageGroups,
            );
            state.pageGroups.add(pgL);

            const page = new Page(
              {
                name: name,
                tag: name.substring(0, 2).toUpperCase() + count, // to avoid double tags if there are more lists
              },
              pgL,
            );
            page.documentType = { type: pageType, name: name };
            pgL.pages.add(page);
            count++;
          }
        }
      }
    }

    // this list has to be in this collection it cont be deleted
    const existingPg10 = state.pageGroups.findFirst((pg) => pg.tag == fixedPageGroupTags.buildingPlans); // only not dynamic pagegroup

    if (!existingPg10) {
      const pg10 = new PageGroup(
        {
          name: state.translate("pageDocumentType.buildingPlans", "Gebäudepläne"),
          tag: fixedPageGroupTags.buildingPlans,
        },
        state.pageGroups,
      );

      state.pageGroups.add(pg10);
    }
  }
}
